import { PropTypes } from 'prop-types'

export const areaSchedulePropType = PropTypes.shape({
    endTime: PropTypes.string,
    endWeekday: PropTypes.string,
    isPeriod: PropTypes.bool,
    startTime: PropTypes.string,
    startWeekday: PropTypes.string,
    weekdays: PropTypes.arrayOf(PropTypes.string)
})
